module.exports = __webpack_public_path__ + "static/media/dropbox.5ca75577.svg";